import React from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Stack,
  IconButton,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EstadoBadge from "../ui/EstadoBadge";
import OrigenBadge from "../ui/OrigenBadge";
import TipoBadge from "../ui/TipoBadge";

/**
 * Vista mobile de incidencias con cards
 */
const IncidenciasMobileList = ({ incidencias, loading, onEdit }) => {
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress sx={{ color: "#cc071e" }} />
      </Box>
    );
  }

  if (!incidencias || incidencias.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography sx={{ color: "#6c757d", fontSize: 14 }}>
          No hay incidencias para mostrar
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2}>
      {incidencias.map((incidencia) => (
        <Card
          key={incidencia.id}
          sx={{
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            borderRadius: 2,
            border: "1px solid #e0e0e0",
          }}
        >
          <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
            {/* Header - ID y Estado */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
              }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#6c757d",
                }}
              >
                #{incidencia.idNote}
              </Typography>

              <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                <EstadoBadge
                  estado={incidencia.estado}
                  label={incidencia.estadoTexto}
                />
                <IconButton
                  size="small"
                  onClick={() => onEdit(incidencia.id)}
                  sx={{ color: "#cc071e", ml: 0.5 }}
                >
                  <EditIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Box>
            </Box>

            {/* Título de la incidencia */}
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 600,
                color: "#212529",
                mb: 1.5,
                lineHeight: 1.4,
              }}
            >
              {incidencia.titulo}
            </Typography>

            <Divider sx={{ my: 1.5 }} />

            {/* Detalles */}
            <Stack spacing={1}>
              {/* Referencia */}
              {incidencia.referencia && (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography sx={{ fontSize: 12, color: "#6c757d" }}>
                    Referencia:
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                    }}
                  >
                    {incidencia.referencia}
                  </Typography>
                </Box>
              )}

              {/* Tipo y Origen */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: 12, color: "#6c757d" }}>
                  Tipo:
                </Typography>
                <TipoBadge tipo={incidencia.tipoNote} />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: 12, color: "#6c757d" }}>
                  Origen:
                </Typography>
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  <OrigenBadge
                    origen={incidencia.origen}
                    label={incidencia.origenLabel}
                  />
                </Box>
              </Box>

              {/* Creado por */}
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ fontSize: 12, color: "#6c757d" }}>
                  Creado por:
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    color: "#495057",
                  }}
                >
                  {incidencia.nombreEmpleado || "Sin asignar"}
                </Typography>
              </Box>

              {/* Fecha de modificación */}
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ fontSize: 11, color: "#6c757d" }}>
                  Modificado:
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#6c757d" }}>
                  {incidencia.fechaModificado}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default IncidenciasMobileList;
